import React from "react";
import RightSideHeader from "./rightSideHeader";
import { styles } from "./styles";
import logo from "../../img/headerLogo.png";
import nkcvts from "../../img/nkc.png";
import config from "../../config/config";
import logoDlb from "../../img/djb.png";
import ioclfleet from "../../img/LOGOIOCL.png";
import watsoofleet from "../../img/watsoo.png";
import sharanLogo from "../../img/png (2).png";

const Header = () => {
  return (
    <header className="header" style={{ zIndex: "100" }}>
      <div style={styles.headerSubContainer}>
        <div style={styles.logoContainer}>
          {config.NkcWeb && (
            <img
              // className={window.location.hostname.split(".")[0]=="cdsfms"?styles.leftSideLogo:""}
              style={
                window.location.hostname.split(".")[0] == "cdsfms"
                  ? styles.leftSideLogo
                  : { width: "" }
              }
              src={
                `${
                  JSON.parse(localStorage.getItem("config")) &&
                  JSON.parse(localStorage.getItem("config"))?.logoUrl == null
                    ? watsoofleet
                    : `${
                        JSON.parse(localStorage.getItem("config")) &&
                        JSON.parse(localStorage.getItem("config"))?.logoUrl
                      }`
                }`
                // sharanLogo
                // sharanLogo
                // window.location.hostname.split(".")[0] == "localhost"
                //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
                //   : window.location.hostname.split(".")[0] == "nkcfms"
                //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
                //   : window.location.hostname.split(".")[0] == "ceigallfms"
                //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
                //   : window.location.hostname.split(".")[0] == "cdsfms"
                //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
                //   : window.location.hostname.split(".")[0] === "192"
                //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
                //   : watsoofleet
              }
              alt="header_icon"
            />
          )}

          {/* {
            config.NkcWeb && 
            <img src={window.location.hostname.split(".")[0]=='ioclfleet'?ioclfleet:window.location.hostname.split(".")[0]=='nkcfms'?JSON.parse(localStorage.getItem("config")).logo:watsoofleet} alt='header_icon' />

          } */}
          {config.VTSWeb && <img src={logo} alt="header_icon" />}
          {config.BJBWeb && <img src={logoDlb} alt="header_icon" />}
        </div>
        <RightSideHeader />
      </div>
    </header>
  );
};

export default Header;
